import apiUrl from '../../../../../utils/settings';

export const getAllRewardsURL = () => {
  return apiUrl + '/user-gifts-v2/all-gifts';
};
export const getgiftDetailUrl = () => {
  return apiUrl + '/user-gifts-v2/gift';
};
export const sendOTPforGiftUrl = () => {
  return apiUrl + '/user-gifts-v2/send-otp-for-gift';
};
export const verifyOTPforGiftUrl = () => {
  return apiUrl + '/user-gifts-v2/verify-otp-for-gift';
};
export const giftHistoryUrl = () => {
  return apiUrl + '/user-gifts-v2/gift-history';
};
export const getNetworkInfluencesURL = () => {
  return apiUrl + '/user-gifts-v2/influencer-gifts';
};
export const downloadPodUrl = () => {
  return apiUrl + '/user-gifts-v2/pod_certificate';
};
export const UploadRewardImageUrl = () => {
  return apiUrl + '/user-gifts-v2/upload-image-for-gift';
};